module.exports = __webpack_public_path__ + "static/media/37_B.2d1d7900.png";